import React from 'react';
import { MessageSquareQuoteIcon, ListOrderedIcon, CrosshairIcon } from 'lucide-react';
import { SlideFrame } from '../deck/SlideFrame';
const snakPoints = [{
  icon: MessageSquareQuoteIcon,
  title: 'Ask inside the Snak',
  body: 'Quizzes and polls sit in the content HCPs already open — no survey, no panel, no incentive.'
}, {
  icon: ListOrderedIcon,
  title: 'Get criteria per HCP',
  body: 'Answers reveal what that individual prescriber actually ranks first, not a segment average.'
}, {
  icon: CrosshairIcon,
  title: 'Educate or target, by name',
  body: 'The gap becomes personal: teach the ones worth teaching, reach the ones who already fit.'
}];
export function ThankYouSlide() {
  return <SlideFrame tone="accent" marker="Thank you" meta="Snakker · Happy to elaborate" isLast data-id="element-146" data-mp="1t6hrzsb119k2">
      <div className="flex min-h-0 flex-1 flex-col justify-center" data-id="element-147" data-mp="1y4jbufga1cwl">
        <h2 className="font-display text-[clamp(36px,6vw,108px)] leading-[1.0] tracking-[-0.005em] text-white" data-id="element-148" data-mp="235yuk0uzf7bt">
          Thank you.
        </h2>
        <p className="mt-[2vh] max-w-[46ch] text-[clamp(13px,1.6vw,27px)] leading-[1.35] text-white/85" data-id="element-149" data-mp="30qllol4a54e4">
          We would be happy to elaborate — including how Snak quizzes and polls
          reveal the real prescription criteria of the{' '}
          <span className="text-white underline decoration-white/40 underline-offset-4" data-id="element-150" data-mp="2rqysgmlpf4w5">
            individual HCP
          </span>
          .
        </p>

        <div className="mt-[4vh] grid shrink-0 grid-cols-3 gap-[2.5%]" data-id="element-151" data-mp="3kel0c71ysvot">
          {snakPoints.map(({
          icon: Icon,
          title,
          body
        }) => <article key={title} className="flex flex-col rounded-2xl bg-white/12 px-[6%] py-[2.4vh]" data-id="element-152" data-mp="3fmbbyvgi03on">
              <Icon aria-hidden="true" className="h-[clamp(16px,1.9vw,30px)] w-[clamp(16px,1.9vw,30px)] text-white" data-id="element-153" data-mp="3amovmd5di7bm" />
              <h3 className="mt-[1.2vh] text-[clamp(12px,1.45vw,24px)] font-semibold leading-[1.2] text-white" data-id="element-154" data-mp="7685gt14gl1w">
                {title}
              </h3>
              <p className="mt-[0.7vh] text-[clamp(10px,1.08vw,18px)] leading-[1.45] text-white/80" data-id="element-155" data-mp="v3nwxdb9jc7z">
                {body}
              </p>
            </article>)}
        </div>
      </div>
    </SlideFrame>;
}